<template>
  <div class="page" @click="handleClose">
    <div class="mask"></div>
    <div class="popup">
      <!-- 弹窗背景 -->
      <div class="popup-bg">
        <img
          :src="require('@/assets/images/YuliApp/weeklyTask/pop_bg@2x.png')"
        />
      </div>

      <!-- 烟花 -->
      <div class="popup-flower-bg flower-fade">
        <img
          :src="
            require('@/assets/images/YuliApp/weeklyTask/bg_pop_move@2x.png')
          "
        />
      </div>

      <!-- 标题 -->
      <div class="popup-bgtitle">
        <img
          :src="
            require('@/assets/images/YuliApp/weeklyTask/claim_rewards@2x.png')
          "
        />
      </div>
      <div class="popup-title">{{ localesPackage?.['katharsis_title']?.[localesEnv] }}</div>
      <!-- 领取物品 -->
      <div class="popup-argview"
          :class="{'popup-argview-more': cur_popup_info?.length > 1}">
        <div class="popup-arg" 
            :class="{
              'popup-arg-more': cur_popup_info?.length > 1,
            }"
            v-for="item in cur_popup_info" 
            :style="{ backgroundImage: `url(${prop_type_img[item?.prop_level || 0]})`, ...item.proStyle }"
            :key="item?.id">
          <img
            :src="
              item.icon_url
                ? item.icon_url
                : require('@/assets/images/YuliApp/weeklyTask/goods_icon_kep@2x.png')
            "
          />
          <p
            class="popup-arg-number"
            :class="{ showBottomMeng: isShowBotMengban, 'popup-arg-number-more': cur_popup_info?.length > 1 }"
          >
            {{ `${isShowBotMengban ? "" : "x"}${item.reward_num}` }}
          </p>
        </div>
      </div>

      <!-- 关闭按钮 -->
      <div class="popup-button" @click="handleClose">
        <!-- <img src="@/assets/images/YuliApp/weeklyTask/popup_close.png" /> -->
        <div class="popup-button-icon">
          <img class="popup-button-icon-left" src="@/assets/images/YuliApp/weeklyTask/close_arrow_icon.svg">
          <span class="popup-button-icon-text">{{ localesPackage?.['og_close_button']?.[localesEnv] }}</span>
          <img class="popup-button-icon-right" src="@/assets/images/YuliApp/weeklyTask/close_arrow_icon.svg">
        </div>
      </div>

      <!-- 三个星星 -->
      <img
        class="star1"
        :src="
          require('@/assets/images/YuliApp/weeklyTask/img_light1_thunder@2x.png')
        "
      />
      <img
        class="star2"
        :src="
          require('@/assets/images/YuliApp/weeklyTask/img_light1_thunder@2x.png')
        "
      />
      <img
        class="star3"
        :src="
          require('@/assets/images/YuliApp/weeklyTask/img_light1_thunder@2x.png')
        "
      />
    </div>
  </div>
</template>
<script>
import { onBeforeMount, onMounted, ref } from "vue";
import { DRAW_CLICK_TYPE } from "@/constants/enums";
import { mapState } from "vuex";

export default {
  props: {
    upBg: {
      type: String,
      default: require("@/assets/images/YuliApp/storageActivity/rewards_pop_up@2x.png"),
    },
    backImage: {
      type: String,
      default: require("@/assets/images/YuliApp/storageActivity/arg_bg.png"),
    },
    isShowBotMengban: {
      type: Boolean,
      default: false,
    },
    cur_popup_info: {
      type: Object,
      default: null,
    },
    // drawClickType: {
    //   type: Number,
    //   default: 1,
    // },
  },
  computed: {
    ...mapState({
      languageEnv: (state) => state.global.languageEnv,
      languagePackage: (state) => state.global.languagePackage,
    }),
  },
  watch: {
    cur_popup_info: {
      handler(value) {
        if (!value) {
          return;
        }
        this.popup_info = value;
      },
      immediate: true,
      deep: true,
    },
    languageEnv: {
      async handler(value) {
        if(value){
          this.localesEnv = value;
        }
      },
      immediate: true,
      deep: true,
    },
    languagePackage: {
      async handler(value) {
        if(value){
          this.localesPackage = value;
        }
      },
      immediate: true,
      deep: true,
    }
  },
  setup(props, ctx) {
    const popup_info = ref(null);
    /**语言包 - ref */
    const localesPackage = ref({});
    /**语言环境 - ref */
    const localesEnv = ref('en');
    const prop_type_img = ref([
        require('@/assets/images/YuliApp/weeklyTask/bg_reward_item_black.svg'),
        require('@/assets/images/YuliApp/weeklyTask/bg_reward_item_white.svg'),
        require('@/assets/images/YuliApp/weeklyTask/bg_reward_item_green.svg'),
        require('@/assets/images/YuliApp/weeklyTask/bg_reward_item_blue.svg'),
        require('@/assets/images/YuliApp/weeklyTask/bg_reward_item_purple.svg'),
        require('@/assets/images/YuliApp/weeklyTask/bg_reward_item_orange.svg')
      ])
    /**
     * 处理关闭
     */
    const handleClose = () => {
      ctx.emit("close", false);
    };
    return {
      handleClose,
      popup_info,
      prop_type_img,
      localesPackage,
      localesEnv
    };
  },
};
</script>

<style lang="less" scoped>
.page {
  width: 100%;
  height: 100%;
  margin-top: -60px;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 999;

  .mask {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    top: 0;
    left: 0;
    animation: maskFade 0.15s ease-in-out both;
  }
  @keyframes maskFade {
    0% {
      background: rgba(0, 0, 0, 0);
    }
    100% {
      background: rgba(0, 0, 0, 0.8);
    }
  }
  .popup {
    position: absolute;
    z-index: 9999;
    width: 100%;
    // height: 264px;
    height: 375px;
    top: 20%;
    text-align: center;
    // background: url("~@/assets/images/YuliApp/weeklyTask/pop_bg@2x.png")
    //   no-repeat top left;
    // background-size: 100% 100%;
    &-bg {
      width: 100%;
      height: 375px;
      animation: bgfade 0.3s ease-in-out both;
      img {
        width: 100%;
        height: 100%;
      }
    }
    @keyframes bgfade {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }
    &-flower-bg {
      position: absolute;
      top: 55%;
      left: 50%;
      transform: translate(-50%, -50%);
      // opacity: 0.7;
      width: 494px;
      height: 494px;
      animation: flowerFade 0.25s linear both 0.05s;

      img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        animation: flower linear both;
        animation-duration: 0.4s;
        width: 100%;
        height: 100%;
      }
    }

    @keyframes flower {
      0% {
        transform: translate(-50%, -50%) scale(1);
      }
      100% {
        transform: translate(-50%, -50%) scale(2.4);
      }
    }

    @keyframes flowerFade {
      0% {
        opacity: 1;
      }
      100% {
        opacity: 0;
      }
    }
    &-bgtitle {
      width: 194px;
      height: 34px;
      position: absolute;
      top: 24px;
      left: 50%;
      transform: translate(-50%, 0);
      img {
        width: 100%;
        height: 100%;
      }
    }
    &-title {
      position: absolute;
      top: 85px;
      left: 50%;
      transform: translate(-50%, 0);
      height: 25px;
      color: rgba(255, 255, 255, 1);
      font-size: 18px;
      font-weight: 700;
      font-family: "PingFang SC";
      text-align: center;
      line-height: 25px;
    }
    &-argview{
      position: absolute;
      top: 169px;
      width: 90%;
      display: flex;
      align-items: center;
      justify-content: center;
      transform: translate(5%, 0);
    }
    &-argview-more{
      height: 180px;
      top: 130px;
      overflow: hidden;
      overflow-y: scroll;
      flex-wrap: wrap;
    }

    &-arg {
      // position: absolute;
      // top: 169px;
      // left: 50%;
      // transform: translate(-50%, 0);
      width: 81.11px;
      height: 81.11px;
      // background-image: url("~@/assets/images/YuliApp/storageActivity/arg_bg.png");
      background-size: 100% 100%;
      text-align: center;
      &-more{
        // 多奖励模式
        position: relative;
        // scale: 1;
        width: 72.25px;
        height: 72.25px;
        margin-right: auto;
        margin-left: auto;
        margin-bottom: 10px;
      }
      img {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 65.33px;
        height: 65.33px;
      }
      &-number {
        position: absolute;
        bottom: -10.5px;
        left: 50%;
        transform: translate(-50%, 0);
        color: rgba(255, 255, 255, 1);
        font-size: 14px;
        font-weight: 500;
        font-family: "PingFang SC";
        text-align: center;
        line-height: 16.8px;
        letter-spacing: 0.91px;
      }
      &-number-more {
        width: 73.4px !important;
      }
      .showBottomMeng {
        bottom: -14px;
        right: -1px;
        width: 82px;
        height: 15px;
        border-radius: 0 0 4px 4px;
        // background: url("~@/assets/images/YuliApp/weeklyTask/png_prop_bg_2@2x.png")
        //   no-repeat top left;
        // background-size: 100% 100%;
        background: rgba(0, 0, 0, 0.4);
        line-height: 15px;
      }
    }
    &-button {
      position: relative;
      z-index: 999;
      margin: 0 auto;
      margin-top: 50px;
      width: 100%;
      display: flex;
      justify-content: center;
      // height: 42px;
      img {
        width: 100%;
        height: 100%;
      }
      &-icon{
        width: 125px;
        height: 16px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        &-text{
          width: 83px;
          height: 16px;
          color: #bcc2c7;
          font-size: 13px;
          font-weight: 400;
          font-family: "PingFang SC";
          text-align: center;
          line-height: 15.6px;
        }
        img{
          width: 13px;
          height: 5.91px;
        }
        &-left{
          transform: rotateY(360deg);
        }
        &-right{
          transform: rotateY(180deg);
        }
      }
    }

    .star1 {
      position: absolute;
      top: 100px;
      left: 10%;
      width: 13px;
      height: 13px;
      animation: starScale 1s ease-in-out infinite alternate;
    }
    .star2 {
      position: absolute;
      top: 130px;
      right: 10%;
      width: 13px;
      height: 13px;
      animation: starScale 1s ease-in-out infinite alternate 0.8s;
      // animation-delay: 0.8s;
    }
    .star3 {
      position: absolute;
      top: 260px;
      right: 25%;
      width: 13px;
      height: 13px;
      animation: starScale 1s ease-in-out infinite alternate 1.7s;
      // animation-delay: 1.7s;
    }

    @keyframes starScale {
      0% {
        transform: scale(0.1);
      }
      100% {
        transform: scale(1);
      }
    }

    @keyframes star1Move {
      0% {
        top: 50%;
        left: 50%;
      }
      100% {
        top: 100px;
        left: 10%;
      }
    }
    @keyframes star2Move {
      0% {
        top: 50%;
        right: 50%;
      }
      100% {
        top: 130px;
        right: 10%;
      }
    }
    @keyframes star3Move {
      0% {
        top: 50%;
        right: 50%;
      }
      100% {
        top: 260px;
        right: 25%;
      }
    }
  }
}
</style>
